import { Tab } from 'bootstrap'
import { useEffect, useRef } from 'react'
import {
	MenuComponent,
	DrawerComponent,
	ScrollComponent,
	ScrollTopComponent,
	StickyComponent,
	ToggleComponent,
	SwapperComponent,
} from '../assets/ts/components'

import { useLayout } from './core'
import { useCookies } from 'react-cookie'
import { useAuthSessionStore } from 'Store/AuthSession'
// import { useChatStore } from 'Store/Chat'
import { shallow } from 'zustand/shallow'

export function MasterInit() {
	const { config } = useLayout()
	const isFirstRun = useRef(true)

	const [cookies] = useCookies(['kumopack-supplier-access-token'])
	const accessToken = cookies['kumopack-supplier-access-token']
	const sessionAccessToken = useAuthSessionStore(state => state.accessToken, shallow)
	// const { getUnreadData } = useChatStore()

	const pluginsInitialization = () => {
		isFirstRun.current = false
		setTimeout(() => {
			ToggleComponent.bootstrap()
			ScrollTopComponent.bootstrap()
			DrawerComponent.bootstrap()
			StickyComponent.bootstrap()
			MenuComponent.bootstrap()
			ScrollComponent.bootstrap()
			SwapperComponent.bootstrap()
			document.querySelectorAll('[data-bs-toggle="tab"]').forEach(tab => {
				Tab.getOrCreateInstance(tab)
			})
		}, 500)
	}

	useEffect(() => {
		if (isFirstRun.current) {
			isFirstRun.current = false
			pluginsInitialization()
		}
	}, [config])

	useEffect(() => {
		if (
			(accessToken !== null && accessToken !== undefined) ||
			(sessionAccessToken !== null && sessionAccessToken !== undefined)
		) {
			// getUnreadData()
			// const intervalId = setInterval(() => {
			// 	getUnreadData()
			// }, 5000)

			// Clear interval on component unmount
			// return () => clearInterval(intervalId)
		}
		// eslint-disable-next-line
	}, [accessToken, sessionAccessToken])

	return <></>
}
